import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import {
	Form,
	FormInput,
	FormButton,
	Margin,
	Text,
} from 'shared/components'
import { auth } from 'routes/route.map'

import * as styles from './styles'

const Step1FormComponent = ({
	form,
	onSubmitForm,
}) => {
	const history = useHistory()

	const handleBackClick = () => {
		history.push(auth.login())
	}

	return (
		<div css={styles.mobileContainer}>
			{/* Header with back arrow and title */}
			<div css={styles.header}>
				<FontAwesomeIcon
					icon="arrow-left"
					css={styles.backArrow}
					onClick={handleBackClick}
				/>
				<div css={styles.headerContent}>
					<Text as="h1" css={styles.title}>
						Sign up
					</Text>
					<Text css={styles.stepIndicator}>
						Step 1/2
					</Text>
				</div>
			</div>

			{/* Form Content */}
			<div css={styles.formContainer}>
				<Margin bottom={3}>
					<Text css={styles.sectionTitle}>
						Required Info:
					</Text>
				</Margin>

				<Form form={form} onSubmit={onSubmitForm}>
					<Margin bottom={3}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									name="nickName"
									placeholder="Nickname"
									error={form.errors?.nickName}
								/>
								{(!form.fields?.nickName?.pureValue || form.fields?.nickName?.pureValue === '') && <span css={styles.asteriskNickname}>*</span>}
							</div>
						</div>
					</Margin>

					<Margin bottom={3}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									name="email"
									type="email"
									placeholder="Email"
									error={form.errors?.email}
								/>
								{(!form.fields?.email?.pureValue || form.fields?.email?.pureValue === '') && <span css={styles.asteriskEmail}>*</span>}
							</div>
						</div>
					</Margin>

					<Margin bottom={3}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									autoComplete="new-password"
									name="password"
									type="password"
									placeholder="Password"
									error={form.errors?.password}
								/>
								{(!form.fields?.password?.pureValue || form.fields?.password?.pureValue === '') && <span css={styles.asteriskPassword}>*</span>}
							</div>
						</div>
					</Margin>

					<Margin bottom={4}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									name="confirmation"
									type="password"
									placeholder="Confirm Password"
									error={form.errors?.confirmation}
								/>
								{(!form.fields?.confirmation?.pureValue || form.fields?.confirmation?.pureValue === '') && <span css={styles.asteriskConfirm}>*</span>}
							</div>
						</div>
					</Margin>

					<Margin bottom={3}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									name="firstName"
									placeholder="Enter your First Name"
									error={form.errors?.firstName}
								/>
								{(!form.fields?.firstName?.pureValue || form.fields?.firstName?.pureValue === '') && <span css={styles.asteriskFirstName}>*</span>}
							</div>
						</div>
					</Margin>

					<Margin bottom={4}>
						<div css={styles.inputContainer}>
							<div css={styles.inputWrapper}>
								<FormInput
									required
									name="lastName"
									placeholder="Enter your Last Name"
									error={form.errors?.lastName}
								/>
								{(!form.fields?.lastName?.pureValue || form.fields?.lastName?.pureValue === '') && <span css={styles.asteriskLastName}>*</span>}
							</div>
						</div>
					</Margin>
				</Form>
			</div>

			{/* Footer */}
			<div css={styles.footerContainer}>
				<Form form={form} onSubmit={onSubmitForm} css={styles.footerForm}>
					{/* Submit Button */}
					<div css={styles.buttonContainer}>
						<FormButton
							submit
							css={styles.submitButton}
						>
							<Text css={styles.buttonText}>
								Save and continue
							</Text>
						</FormButton>
					</div>
				</Form>

				{/* Progress Indicator */}
				<div css={styles.progressContainer}>
					<div css={styles.progressBar}></div>
				</div>
			</div>
		</div>
	)
}

Step1FormComponent.propTypes = {
	form: PropTypes.shape().isRequired,
	onSubmitForm: PropTypes.func.isRequired,
}

export default observer(Step1FormComponent) 